import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LangContext";
import Reveal from "@/components/Reveal";
import { FOOD_IMAGES } from "@/data/content";

const IMG = FOOD_IMAGES.scallopsCitrus;

export default function Philosophy() {
  const { t } = useLang();

  return (
    <div data-testid="page-philosophy">
      <section className="bg-[#070E13] text-[#F4EEE8] pt-40 pb-24">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12">
          <Reveal>
            <p className="overline text-[#C7A26C]">{t.philosophy.eyebrow}</p>
            <h1 className="h-editorial text-5xl sm:text-6xl lg:text-7xl mt-6 max-w-4xl">{t.philosophy.title}</h1>
            <p className="mt-8 max-w-2xl text-lg text-[#F4EEE8]/75">{t.philosophy.lead}</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#0C1821] py-24 sm:py-32 border-y border-[#C7A26C]/15">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12 space-y-20">
          {t.philosophy.sections.map((s, i) => (
            <Reveal key={i} delay={i * 100}>
              <div className={`grid grid-cols-1 md:grid-cols-12 gap-8 items-start`}>
                <div className="md:col-span-2">
                  <p className="font-serif text-6xl gold-text opacity-80">0{i + 1}</p>
                </div>
                <div className="md:col-span-10">
                  <h2 className="h-editorial text-3xl sm:text-4xl text-[#F4EEE8]">{s.t}</h2>
                  <p className="mt-5 text-lg text-[#D6D1C9] leading-relaxed max-w-2xl">{s.d}</p>
                </div>
              </div>
              {i < t.philosophy.sections.length - 1 && <hr className="mt-20 border-[#C7A26C]/20" />}
            </Reveal>
          ))}
        </div>
      </section>

      <section className="relative bg-[#070E13] text-[#F4EEE8] overflow-hidden">
        <img src={IMG} alt="Wellbeing" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-[#070E13]/70" />
        <div className="relative max-w-5xl mx-auto px-6 py-32 text-center">
          <Reveal>
            <p className="font-serif italic text-4xl sm:text-5xl leading-snug">
              Reset. Rebuild. Sustain.
            </p>
            <Link
              to="/contact"
              data-testid="philosophy-cta"
              className="inline-flex items-center gap-2 mt-12 px-7 py-4 bg-[#C7A26C] text-[#070E13] text-xs uppercase tracking-[0.2em] hover:bg-[#E8DFC8] transition-colors"
            >
              {t.common.bookConsultation}
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
